import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DropdownMenuState } from 'src/components/GlobalPageV2/DropdownMenu/DropdownMenu.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { PagesGetType } from 'src/AppState/PagesState/PagesState';
import { PagesStateV2 } from 'src/AppState/PagesState/PagesStateV2';
import { ListItemComponent } from './ListItemComponent';

interface ListItemV2PropsType {
    page: PagesGetType;
}
interface DropdownItemType {
    label: string;
    onClick?: () => void;
}

const dropdownMenuItems = (state: PagesStateV2, page: PagesGetType): DropdownItemType[] => {
    return [
        {
            label: 'Edit',
            onClick: () => state.setEditedPage(page),
        },
        // {
        //     label: 'Duplicate',
        // },
        {
            label: 'Delete',
            onClick: () => state.onRemove(page),
        },
    ];
};

export const ListItemPage = observer((props: ListItemV2PropsType) => {
    const { page } = props;
    const [dropdownState] = useState(() => new DropdownMenuState());
    const { pagesStateV2 } = useAppStateContext();

    const dropdownItemsForView = dropdownMenuItems(pagesStateV2, page);

    return (
        <ListItemComponent
            title={page.title}
            dropdownState={dropdownState}
            dropdownItemsForView={dropdownItemsForView}
        />
    );
});
